import Loading from "./loading";

export default {
  install(Vue) {
    const LoadingComponent = Vue.extend(Loading);
    let loading;
    const instance = () => {
      if (loading) return loading;
      loading = new LoadingComponent();
      document.body.appendChild(loading.$mount().$el);
      return loading;
    };
    Vue.prototype.$loading = {
      show() {
        instance().show();
      },
      hide() {
        instance().hide();
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/loading/index.js